import { fcaFastApi } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";

export const getStatusData = (params, id) => fcaFastApi.get(`${serviceEndpoints.projectEndPoints.getStatus}`, { params });
export const postStatus = params => fcaFastApi.post(`${serviceEndpoints.projectEndPoints.getStatus}`, params);
export const updateStatus = (id, params) => fcaFastApi.put(`${serviceEndpoints.projectEndPoints.getStatus}${id}`, params);
export const statusDropdown = id => fcaFastApi.get(`${serviceEndpoints.projectEndPoints.getStatus}dropdown/${id}`);
export const restoreStatusLog = (id, params) => fcaFastApi.put(`${serviceEndpoints.projectEndPoints.activityLog}${id}`, { params });
export const deleteStatus = id => fcaFastApi.delete(`${serviceEndpoints.projectEndPoints.getStatus}${id}`);
